import axios from 'axios';
import apiUrl from '../../../constants';

export default new class {
  async getCompanyShortName(input) {
    try {
      let result = await axios({
        method: 'GET',
        'url': apiUrl.api_url + 'external/getCargoClientList',
        'data': input,
      });
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getApprovalRequest(input){
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'approvalhierarchy/getapprovalrequest',
        'data': input,
      });
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getCompletedApprovalRequest(input){
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'approvalhierarchy/getcompletedapprovalrequest',
        'data': input,
      });
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getCityList(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargomaster/getcitylist',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getStateList() {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargomaster/getstatelist'
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getClientNameExist(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'cargoclientkyc/clientonboard',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async checkavailabilityforapprove(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'approvalhierarchy/checkavailabilityforapprove',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async rejectrequest(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'approvalhierarchy/rejectrequest',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async approveRequest(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'approvalhierarchy/approvalrequestforlog',
        'data': input,
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getActiveInactiveClientList() {
    try {
      let result = await axios({
        method: 'GET',
        'url': apiUrl.api_url + 'external/cargoclientkyc/getactiveinactiveclient',
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async getAllPendingApproveRequest(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'approvalhierarchy/getallpendingrequestofusers',
        'data': input
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async approveRequestForContractAndRate(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'approvalrequest/approve',
        'data': input
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
  async rejectRequestForContractAndRate(input) {
    try {
      let result = await axios({
        method: 'POST',
        'url': apiUrl.api_url + 'approvalrequest/rejectrequest',
        'data': input
      })
      return result;
    } catch (err) {
      throw new Error(err);
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/requests/services/requests.service.js